import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Constants } from '@app/common/constants';
import { HttpHelper } from '@app/common/http-helper';
import { FollowedPage } from '@app/models/followed-page';
import { CacheService } from '@app/services/cache.service';
import { concat, Observable, of, Subject } from 'rxjs';
import { catchError, map, shareReplay, takeUntil, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MyFollowedPagesService {

  constructor(private httpClient: HttpClient, private cache: CacheService, private httpHelper: HttpHelper) { }

  public useCache = true;
  private readonly cacheKeyPrefix = 'MyFollowedPagesService';

  private myFollowedPages$ = new Map<string, Observable<Array<FollowedPage>>>();
  private reload$ = new Subject<void>();

  public reload() {

    this.reload$.next();
    this.myFollowedPages$ = null;
  }

  getMyFollowingPages(amountOfItems: number): Observable<Array<FollowedPage>> {

    const params = new HttpParams()
      .append('$top', amountOfItems.toString());

    const param = `${amountOfItems}`;
    if (this.myFollowedPages$ && this.myFollowedPages$.has(param)) {
      return this.myFollowedPages$.get(param);
    } else {

      const cacheKey = `${this.cacheKeyPrefix}-${'MyFollowingPages'}-${param}`;
      this.myFollowedPages$ = new Map<string, Observable<Array<FollowedPage>>>();

      this.myFollowedPages$.set(param, this.httpClient.get<any>(`${Constants.GRAPH_API_ENDPOINT + Constants.GRAPH_API_BETA_VERSION}/me/drive/following`, {
        params: params
      })
        .pipe(
          map(result => {
            console.log(`fetched my following pages result: `);
            console.log(result);
            return result.value
              .map(page => {
                return new FollowedPage({
                  Id: page.id,
                  Path: page.webUrl,
                  Title: page.name.split('.')[0],
                  DriveId: page.parentReference.driveId,
                  Icon: 'SingleBookmarkSolid',
                  ShowIcon: false
                });
              });
          }),
          tap(response => {
            console.log(`fetched result: fetched my following pages `, response);
            this.useCache && this.cache.set(cacheKey, response as Array<FollowedPage>);
          }),
          catchError(this.httpHelper.handleError({ operation: 'getMyFollowing', result: new Array<FollowedPage>(), cacheKey: cacheKey })),
          takeUntil(this.reload$),
          shareReplay({ bufferSize: 1, refCount: true })));

      if (this.useCache) {
        const cachedData = this.cache.get<any>(cacheKey);
        if (cachedData) {
          return concat(of(cachedData), this.myFollowedPages$.get(param));
        }
      }

      return this.myFollowedPages$.get(param);
    }
  }

  removePage(page: FollowedPage) {
    const fetchOperation = this.httpClient.delete<any>(`${Constants.GRAPH_API_ENDPOINT + Constants.GRAPH_API_BETA_VERSION}/me/drives/${page.DriveId}/following/${page.Id}`,
      {
      })
      .pipe(
        map(response => {
          console.log(`removed page: `);
          console.log(response);
          this.reload();
        }),
        catchError(this.httpHelper.handleError({ operation: 'remove page from saved/bookmarked', result: true })));
    return fetchOperation;
  }

}
